<div class="dashboard">
  <div class="dashboard-header">
    <div class="title">
      <h1>
        <span class="gray-text">Welcome </span> {{userFirstName}}!
        <a routerLink="/dashboard-edit" *appHasRole="['Master Admin']" pTooltip="Edit Dashboard">
          <span class="icon material-icons">settings</span>
        </a>
      </h1>
    </div>
    <ng-container *ngIf="dashboardConfig">
      <ng-container *ngIf="dashboardConfig.phases.length > 0">
        <div class="tabs-area">
          <div class="tabs-navigation" *ngIf="dashboardConfig.phases.length !== 1">
            <button
              (click)="navigateToPrevPhase()"
              class="tabs-navigation-button tabs-navigation-button-prev"
              [ngClass]="{'disabled': selectedPhaseIndex === 0}"
              [disabled]="selectedPhaseIndex === 0"
            >
              <span class="icon material-icons">chevron_left</span>
            </button>
            <button
              (click)="navigateToNextPhase()"
              class="tabs-navigation-button tabs-navigation-button-next"
              [ngClass]="{'disabled': selectedPhaseIndex === (dashboardConfig.phases.length - 1)}"
              [disabled]="selectedPhaseIndex === (dashboardConfig.phases.length - 1)"
            >
              <span class="icon material-icons">chevron_right</span>
            </button>
          </div>
          <div class="tabs-wrapper">
            <mat-tab-group [selectedIndex]="selectedPhaseIndex" (selectedIndexChange)="selectedPhaseIndex = $event">
              <mat-tab *ngFor="let phase of dashboardConfig.phases">
                <ng-template mat-tab-label>
                  <div class="phase-label-wrap">
                    <h5 class="phase-title">{{ phase.phaseTitle }}</h5>
                    <span class="phase-period">{{ phase.phaseDateLabel }}</span>
                    <span class="phase-progress" *ngIf="phase.phaseProgress !== null">
                      <span class="phase-progress-inner" [ngStyle]="{'width': phase.phaseProgress + '%'}"></span>
                    </span>
                  </div>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <ng-container *ngIf="dashboardConfig">
    <div class="widgets-area" *ngIf="dashboardConfig.phases[selectedPhaseIndex]">
      <div class="widgets-inner-wrapper">
        <ng-container *ngFor="let widget of dashboardConfig.phases[selectedPhaseIndex].widgets">
          <div
            class="widget-wrapper"
            [ngStyle]="{'flex-basis': widget.widgetHorizontalPercentageSize + '%'}"
          >
            <ng-container [ngSwitch]="widget.widgetType">
              <ng-container *ngSwitchCase="'form'">
                <widget-form [widgetConfig]="widget"></widget-form>
              </ng-container>
              <ng-container *ngSwitchCase="'timeline'">
                <widget-timeline [widgetConfig]="widget"></widget-timeline>
              </ng-container>
              <ng-container *ngSwitchCase="'news'">
                <widget-news [widgetConfig]="widget"></widget-news>
              </ng-container>
              <ng-container *ngSwitchCase="'forums'">
                <widget-forums [widgetConfig]="widget"></widget-forums>
              </ng-container>
              <ng-container *ngSwitchCase="'admin-review'">
                <widget-admin-review [widgetConfig]="widget"></widget-admin-review>
              </ng-container>
              <ng-container *ngSwitchCase="'peer-review'">
                <widget-peer-review [widgetConfig]="widget"></widget-peer-review>
              </ng-container>
              <ng-container *ngSwitchCase="'evaluation-participant'">
                <widget-evaluation-participant [widgetConfig]="widget"></widget-evaluation-participant>
              </ng-container>
              <ng-container *ngSwitchCase="'evaluation-judge'">
                <widget-evaluation-judge [widgetConfig]="widget"></widget-evaluation-judge>
              </ng-container>
              <ng-container *ngSwitchCase="'content-1'">
                <widget-content-1 [widgetConfig]="widget"></widget-content-1>
              </ng-container>
              <ng-container *ngSwitchCase="'content-2'">
                <widget-content-2 [widgetConfig]="widget"></widget-content-2>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>